import { useState } from "react";
import { FaStopCircle } from "react-icons/fa";

function EndInterviewButton({ endInterview }) {
  const [showDialog, setShowDialog] = useState(false);

  return (
    <div className="">
      {/* End Interview Button with Tooltip */}
      <button
        className=" flex flex-row items-center justify-center
        bg-red-500 text-white px-6 py-4 rounded-lg
         hover:bg-red-600 transition relative"
        //onMouseEnter={() => setShowDialog(false)}
        onClick={() => setShowDialog(true)}
      >
         <FaStopCircle className="text-3xl" /> &nbsp; &nbsp;
        <span>End Interview </span>
       
        {/* Tooltip */}
        <span className="absolute -top-8 left-1/2 -translate-x-1/2 bg-gray-800 text-white text-sm px-2 py-1 rounded-lg opacity-0 hover:opacity-100 transition">
          End the Interview
        </span>
        
      </button>

      {/* Confirmation Dialog */}
      {showDialog && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 text-center">
          <div className="bg-white text-gray-800 p-6 px-8 rounded-lg shadow-lg">
            <p className="text-xl  mb-4">
                Are you sure you want to end this interview session?
                 <br /><br />
                You will not be able to restart this discussion. 
                <br /><br />
                </p>
            <div className="flex justify-evenly">
              <button
                className="bg-red-500 text-white px-6  p-4 rounded-lg hover:bg-red-600"
                onClick={() => {
                  setShowDialog(false);
                  endInterview(); // Call callback
                }}
              >
                Yes, End Interview
              </button>
              <button
                className="bg-teal-500 text-white px-6 p-4 rounded-lg hover:bg-teal-600"
                onClick={() => setShowDialog(false)}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export {EndInterviewButton};